import React from "react"
import { Button } from "primereact/button"
import { Dialog } from 'primereact/dialog'
import { MdError } from 'react-icons/md'

import './error.css'

export default function DialogErrorNoReload({ openDialog, setOpenDialog, messageHeader, messageBody }) {
  const close = () => {
    setOpenDialog(false)
  }

  const footer = (
    <div>
      <Button label="Ok" icon="pi pi-check" onClick={close} />
    </div>
  );


  return (
    <Dialog header={messageHeader} footer={footer} visible={openDialog} style={{ width: '50vw' }} modal={true} onHide={close}>
      <div className="dialog-content">
        <MdError color="red" fontSize={50} />
        <h1>{messageBody}</h1>
      </div>
    </Dialog>
  )
}